import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { styles } from "./styles";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { STRINGS } from "../../../Marketing/strings";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { GREY } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import CampaignSignatures from "./CampaignSignatures";
import MailboxGroups from "./MailboxGroups";
import { useSetupWizard } from "../../../../context/SetupWizardContext";

const TAB_SIGNATURES = "signatures";
const TAB_GROUPS = "groups";

export const CampaignSetting = () => {
  const classes = styles();
  const navigate = useNavigate();
  const location = useLocation();
  const { currentStepKey } = useSetupWizard();
  const [activeTab, setActiveTab] = useState(
    currentStepKey === "signature" ? TAB_SIGNATURES : TAB_GROUPS
  );

  useEffect(() => {
    if (currentStepKey === "signature") {
      setActiveTab(TAB_SIGNATURES);
    }
  }, [currentStepKey]);

  useEffect(() => {
    navigate({
      pathname: location.pathname,
      search: createSearchParams({ tab: "CampaignDefaults" }).toString(),
    });
    const ele = document.getElementById("campaignDefaultContainer");
    if (ele) ele.scrollTop = 0;
  }, [navigate, location.pathname]);

  const isGroups = activeTab === TAB_GROUPS;
  const headerLabel = isGroups
    ? STRINGS.MAILBOX_GROUPS
    : STRINGS.EMAIL_SIGNATURES;
  const headerDesc = isGroups
    ? STRINGS.MAILBOX_GROUPS_DESC
    : STRINGS.EMAIL_SIGNATURES_DESC;

  return (
    <Box className={classes.container}>
      <Box className={classes.security} id="campaignDefaultContainer">
        <Box className={classes.headerWrapCamp}>
          <TypographyInline
            size={"md"}
            color={GREY.PRIMARY}
            fontWeight={fontWeight.MEDIUM}
            label={headerLabel}
          />
          <TypographyInline
            size={"sm"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.REGULAR}
            label={headerDesc}
          />
        </Box>

        <Box className={classes.campTabsBar} role="tablist">
          <Box
            role="tab"
            aria-selected={isGroups}
            tabIndex={0}
            className={`${classes.campTab} ${
              isGroups ? classes.campTabActive : ""
            }`}
            onClick={() => setActiveTab(TAB_GROUPS)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setActiveTab(TAB_GROUPS);
              }
            }}
          >
            {STRINGS.TAB_GROUPS}
          </Box>
          <Box
            role="tab"
            aria-selected={!isGroups}
            tabIndex={0}
            className={`${classes.campTab} ${
              !isGroups ? classes.campTabActive : ""
            }`}
            onClick={() => setActiveTab(TAB_SIGNATURES)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setActiveTab(TAB_SIGNATURES);
              }
            }}
          >
            {STRINGS.TAB_SIGNATURES}
          </Box>
        </Box>

        <Box className={classes.campaignAuto}>
          {isGroups ? <MailboxGroups /> : <CampaignSignatures />}
        </Box>
      </Box>
    </Box>
  );
};
